export default "<div class=\"button-container\">\n  <p>start now</p>\n</div>\n"